import { render, staticRenderFns } from "./assetDetails.vue?vue&type=template&id=973ae77c&scoped=true&"
import script from "./assetDetails.vue?vue&type=script&lang=js&"
export * from "./assetDetails.vue?vue&type=script&lang=js&"
import style0 from "./assetDetails.vue?vue&type=style&index=0&id=973ae77c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973ae77c",
  null
  
)

export default component.exports